import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AppErrorMessagesComponent } from 'src/app/base/error-messages/app-error-messages.component';

import { YesNoGroupButtonComponent } from 'src/app/base/shared/yes-no-group-button/yes-no-group-button.component';

@Component({
    selector: 'app-client-administraion-edit-form',
    templateUrl: './client-administraion-edit-form.component.html',
    styleUrls: ['./client-administraion-edit-form.component.scss'],
    imports: [TranslateModule, ReactiveFormsModule, AppErrorMessagesComponent, YesNoGroupButtonComponent]
})
export class ClientAdministraionEditFormComponent {

  @Input() public clientEditForm: UntypedFormGroup;

  public get isEdit(): boolean {
    return !!this.clientEditForm.get('id').value
  }

  constructor() { }
}
